// ------------------------------------
// props 輸入需求 :
// props.isON : boolean                                   ( 元件開關 )
// props.setReturnShift : function( params : str )        ( 回傳 : str ('morn', 'mid', 'night') )
// ------------------------------------


import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import Account from '../../../../actions/Account';


const ThreeShift =(props)=>{
    const { t } = useTranslation(); // 1.2 i18n

    // 三班 選到的回傳值 : shiftSelected (mid/ morn / night)
    const [shiftOpen, setShiftOpen] = useState();
    function toggleShiftOpen(){ setShiftOpen(!shiftOpen) }
    const [shiftSelected, setShiftSelected] = useState('ALL');
    const shift_show = ((shiftSelected==="MS")? t("HISTORY_RECORD.MORNING_SHIFT"):((shiftSelected==="NS")? t('HISTORY_RECORD.NIGHT_SHIFT'):((shiftSelected==="GS")? t('HISTORY_RECORD.MIDNIGHT_SHIFT'):t("HISTORY_RECORD.ALL"))))

    function clickShift(e){
        setShiftSelected(e.target.id)
        props.setReturnShift(e.target.id)
    }
    if(Account.isMobileOrTablet()){
        return(
            <div className={`${Account.isMobile()?"littleUi":"col-2"} fx-ccc`}>
                {props.isON?
                    <div className="top-tag fx-d-c mar-l">
                        <div className="name m fx-ccc">{t("HISTORY_RECORD.THREE_SHIFT")}</div>
                        <div className="fx-ccc h-50">
                            <div className="" onClick={toggleShiftOpen}>{shift_show}</div>
                            {shiftOpen && (
                                <div className="pos-f z-1 wid-full hig-full top-0 left-0 cursor-def" onClick={toggleShiftOpen}>
                                    <div className="pos-a shift m">
                                        <div id="ALL" className="individual" onClick={clickShift}>{t('HISTORY_RECORD.ALL')}</div>
                                        <div id="MS" className="individual" onClick={clickShift}>{t('HISTORY_RECORD.MORNING_SHIFT')}</div>
                                        <div id="NS" className="individual" onClick={clickShift}>{t('HISTORY_RECORD.NIGHT_SHIFT')}</div>
                                        <div id="GS" className="individual" onClick={clickShift}>{t('HISTORY_RECORD.MIDNIGHT_SHIFT')}</div>
                                    </div>
                                </div>
                                )}
                        </div>
                    </div>
                :null}
            </div>
        );
    }
    else{
        return(
            <div className="col-4 fx-ccc ">
                {props.isON?
                    <div className="top-tag fx-d-r mar-l">
                        <div className="name fx-ccc">{t("HISTORY_RECORD.THREE_SHIFT")}</div>
                        <div className="body h-50">
                            <div className="inner" onClick={toggleShiftOpen}>{shift_show}</div>
                            {shiftOpen && (
                                <div className="pos-f z-max wid-full hig-full top-0 left-0 cursor-def" onClick={toggleShiftOpen}>
                                    <div className="pos-a shift">
                                        <div id="ALL" className="individual" onClick={clickShift}>{t('HISTORY_RECORD.ALL')}</div>
                                        <div id="MS" className="individual" onClick={clickShift}>{t('HISTORY_RECORD.MORNING_SHIFT')}</div>
                                        <div id="NS" className="individual" onClick={clickShift}>{t('HISTORY_RECORD.NIGHT_SHIFT')}</div>
                                        <div id="GS" className="individual" onClick={clickShift}>{t('HISTORY_RECORD.MIDNIGHT_SHIFT')}</div>
                                    </div>
                                </div>
                                )}
                        </div>
                    </div>
                :null}
            </div>
        );
    }
}
export default ThreeShift;